import { OpenAIResponse } from "../../rule-engine-core/Plugins/OpenAPI/OpenAIResponse";
import { useState } from "react";
import { OpenAIChatLayer } from "./OpenAIChatLayer";
import PsychologyIcon from "@mui/icons-material/Psychology";
import { UIButton } from "../BuildlingBlocks/UIButton";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export function OpenAIChatLink(props: {
    linkName: string;
    title: string;
    pretext?: string;
    posttext?: string;
    label?: string;
    initialPrompt?: string;
    priorConversation?: OpenAIResponse<string>;
    onSelectAnswer?: (answer: string) => void;
    needsClean?: (text: string) => boolean;
    light?: boolean;
}) {
    let [open, setOpen] = useState<boolean>(false);

    return (
        <>
            <UIButton
                sx={{
                    textTransform: "none",
                }}
                color={props.light ? UIStyleConstants.WHITE_COLOR : UIStyleConstants.BLUE_COLOR}
                variant={"text"}
                startIcon={<PsychologyIcon />}
                onClick={() => setOpen(true)}
            >
                {props.linkName}
            </UIButton>

            {open && (
                <OpenAIChatLayer
                    title={props.title}
                    onClose={() => setOpen(false)}
                    open={open}
                    pretext={props.pretext}
                    posttext={props.posttext}
                    initialPrompt={props.initialPrompt}
                    priorConversation={props.priorConversation}
                    onSelectAnswer={(a) => {
                        setOpen(false);
                        if (props.onSelectAnswer) props.onSelectAnswer(a);
                    }}
                    needsClean={props.needsClean}
                />
            )}
        </>
    );
}
